import { useEffect, useState } from 'react';
import { store } from '@/lib/store';

export function usePebble() {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force(n => n + 1);
    window.addEventListener('pebble-update', fn);
    return () => window.removeEventListener('pebble-update', fn);
  }, []);
  return store;
}

export function useStoreLoaded() {
  const [loaded, setLoaded] = useState(store.isLoaded());
  useEffect(() => {
    const fn = () => setLoaded(store.isLoaded());
    window.addEventListener('pebble-update', fn);
    return () => window.removeEventListener('pebble-update', fn);
  }, []);
  return loaded;
}
